import { render, staticRenderFns } from "./AdminReportsPresetDialogSave.vue?vue&type=template&id=9c6761a0&scoped=true"
import script from "./AdminReportsPresetDialogSave.vue?vue&type=script&lang=js"
export * from "./AdminReportsPresetDialogSave.vue?vue&type=script&lang=js"
import style0 from "./AdminReportsPresetDialogSave.vue?vue&type=style&index=0&id=9c6761a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6761a0",
  null
  
)

export default component.exports